<template>
  <default-layout>
    <v-layout wrap>
      <v-flex xs12>
        <fundi-menu-bar></fundi-menu-bar>
      </v-flex>
      <v-flex xs4>
        <v-autocomplete
          :items="packages"
          v-model="packageOption"
          label="Select Package"
          single-line
          item-text="name"
          item-value="_id"
          required
        ></v-autocomplete>
      </v-flex>

      <v-flex xs4>
        <v-btn small color="orange darken-2" dark @click="findData" :loading="loader">Find Subscriptions</v-btn>
      </v-flex>

      <v-flex xs12 class="mt-3">
        <fundi-table :fundis="subscriptions"></fundi-table>
      </v-flex>
    </v-layout>
  </default-layout>
</template>
<script>
import FundiMenuBar from "../_components/fundi_menu.vue";
import FundiTable from "../_components/subs_table.vue";
export default {
  name: "FundisFilterPage",
  components: {
    FundiMenuBar,
    FundiTable
  },
  data() {
    return {
      fundis: [],
      experts: [],
      filteredExperts: [],
      category: null,
      packages: [],
      packageOption: null,
      subscriptions: [],
      loader: false,
      search: "",
      headers: [
        {
          text: "First Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        { text: "Last Name", value: "phone" },
        { text: "Phone", value: "title" },
        { text: "Email", value: "category" },
        { text: "Location", value: "location" }
      ]
    };
  },
  methods: {
    findData() {
      const pId = this.packageOption;
      const self = this;
      this.loader = true;
      this.$store.dispatch("get", "/subscription/" + pId).then(res => {
        self.subscriptions = res.records;
        self.loader = false;
      });
    },
    getExperts() {
      this.$store.dispatch("get", "/user/all/experts").then(res => {
        this.fundis = res.experts;
      });
    },
    getPackages() {
      this.$store.dispatch("get", "/packages").then(res => {
        this.packages = res.packages;
      });
    },
    getSubscriptions() {
      this.$store.dispatch("get", "/subscription").then(res => {
        this.subscriptions = res.records;
      });
    }
  },
  created() {
    // this.getExperts();
    this.getPackages();
    this.getSubscriptions();
  }
};
</script>
